module.exports = __webpack_public_path__ + "static/media/more.80a08b81.png";